<template>
    <div>
        <CMBSHeader/>
        <router-view/>
        <!-- <MusaFooter v-if="bgClsName!='bd2'&&bgClsName!='bd3'&&bgClsName!='none'"/> -->
    </div>
</template>

<script>
import CMBSHeader from '@/components/header'
export default {
    components:{
        CMBSHeader
    },
    watch: {
		
	},
    data(){
        return{
           
        }
    },
    mounted(){
       
    },
    methods:{
       
    }
}
</script>



// WEBPACK FOOTER //
// src/views/layout.vue